// extracted by mini-css-extract-plugin
export var skipAnimation = "_4i-0";